const modifiedFields = ['ruleModel', 'notificationsModel'];
const modifiedFieldCustom = {
    ruleModel: [
        'eventLevel',
        'metricKey',
        'objectModel',
        'metricFunction',
        'prefix',
        'ftCount',
        'thresholdMax',
        'thresholdMin',
        'thresholdItem',
        'check_statistics',
        'statisticsType',
        'statisticsPeriod',
        'disableYn',
        'eventOccurTimeZone'
    ],
    notificationsModel: ['recipientKey', 'recipientName', 'notificationMethods', 'recipientType']
};
const sortByFields = {
    notificationsModel: ['recipientName'],
    orderBy: ['asc']
};
const addFields = ['productsModel', 'eventRules', 'usersSelected'];
const addFieldCustom = {};

export default {
    eventSettingAdd: {
        modifiedFields: addFields,
        modifiedFieldCustom: addFieldCustom
    },
    eventSettingEdit: {
        modifiedFields,
        modifiedFieldCustom,
        sortByFields
    }
};
